"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var theme_1 = require("../../core/theme");
exports.default = {
    volumeSvgFill: {
        fill: function (data) { return data.color; },
    },
    volumeSvgStroke: {
        stroke: function (data) { return data.color; },
    },
    volumeProgress: {
        backgroundColor: function (data) { return data.color; },
        '&:after': {
            backgroundColor: function (data) { return data.color; },
        },
    },
    volumeProgressBackground: {
        backgroundColor: function (data) {
            return theme_1.transperentizeColor(data.color, 0.25);
        },
    },
};
//# sourceMappingURL=volume.theme.js.map